export default __webpack_public_path__ + "static/media/13.fb008c68.jpg";